import { render, staticRenderFns } from "./trainspressmange.vue?vue&type=template&id=567803e1&scoped=true"
import script from "./trainspressmange.vue?vue&type=script&lang=js"
export * from "./trainspressmange.vue?vue&type=script&lang=js"
import style0 from "./trainspressmange.vue?vue&type=style&index=0&id=567803e1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567803e1",
  null
  
)

export default component.exports